import { namespace } from '../index';
const _scopedState = (state) => state[namespace];

const userFieldValue = (state) => _scopedState(state).userFieldValue;
const userFieldName = (state) => _scopedState(state).userFieldName;

const passwordFieldValue = (state) => _scopedState(state).passwordFieldValue;
const passwordFieldName = (state) => _scopedState(state).passwordFieldName;

const rememberMeFieldValue = (state) => _scopedState(state).rememberMeFieldValue;
const rememberMeFieldName = (state) => _scopedState(state).rememberMeFieldName;

const totpCodeFieldValue = (state) => _scopedState(state).totpCodeFieldValue;
const totpCodeFieldName = (state) => _scopedState(state).totpCodeFieldName;

const loginType = (state) => _scopedState(state).loginType;
const secondaryLoginType = (state) => _scopedState(state).secondaryLoginType;
const skipCountdown = (state) => _scopedState(state).skipCountdown;
const cesSupportUrl = (state) => _scopedState(state).cesSupportUrl;
const cesAuthLoginUrl = (state) => _scopedState(state).cesAuthLoginUrl;

export default {
  userFieldValue,
  userFieldName,

  passwordFieldValue,
  passwordFieldName,

  rememberMeFieldValue,
  rememberMeFieldName,

  totpCodeFieldValue,
  totpCodeFieldName,

  loginType,
  secondaryLoginType,
  skipCountdown,
  cesSupportUrl,
  cesAuthLoginUrl,
};
